export const baseUrl = "https://nj-apis.onrender.com/api";
